import { useTranslation } from "react-i18next";
import { Trash2, Users } from "lucide-react";
import { useAppDispatch } from "../../../app/hooks";
import { ImportMember } from "../models/ImportMember";
import { removeMember, updateMember } from "../assistant-import-slice";

interface ProposalMembersSectionProps {
  members: ImportMember[];
}

export function ProposalMembersSection({ members }: ProposalMembersSectionProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  if (members.length === 0) return null;

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6">
      <div className="mb-4 flex items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-95 text-primary-50 dark:bg-primary-30 dark:text-primary-80">
          <Users size={20} strokeWidth={2} />
        </span>
        <h2 className="text-lg font-semibold">
          {t("assistantImport.review.members")} ({members.length})
        </h2>
      </div>

      <div className="space-y-3">
        {members.map((member) => {
          return (
            <div key={member.tempId} className="rounded-xl bg-grey-95 dark:bg-primary-20 p-3">
              <div className="flex flex-wrap items-start gap-2">
                <input
                  className="input flex-1 min-w-[140px]"
                  aria-label={t("assistantImport.review.firstName")}
                  placeholder={t("assistantImport.review.firstName")}
                  value={member.firstName}
                  onChange={(e) =>
                    dispatch(updateMember({ tempId: member.tempId, changes: { firstName: e.target.value } }))
                  }
                />
                <input
                  className="input flex-1 min-w-[140px]"
                  aria-label={t("assistantImport.review.lastName")}
                  placeholder={t("assistantImport.review.lastNameOptional")}
                  value={member.lastName}
                  onChange={(e) =>
                    dispatch(updateMember({ tempId: member.tempId, changes: { lastName: e.target.value } }))
                  }
                />
                <input
                  className="input flex-1 min-w-[180px]"
                  aria-label={t("assistantImport.review.email")}
                  placeholder={t("assistantImport.review.emailOptional")}
                  type="email"
                  value={member.email ?? ""}
                  onChange={(e) =>
                    dispatch(
                      updateMember({
                        tempId: member.tempId,
                        changes: { email: e.target.value.length > 0 ? e.target.value : null },
                      }),
                    )
                  }
                />
                <button
                  type="button"
                  className="btn btn-text text-red-700 dark:text-red-400"
                  aria-label={t("common.remove")}
                  onClick={() => dispatch(removeMember(member.tempId))}
                >
                  <Trash2 size={18} />
                </button>
              </div>
              {member.notes && (
                <p className="mt-2 text-sm text-grey-50 dark:text-grey-70">
                  {t("assistantImport.review.notes")}: {member.notes}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
